import React from 'react'
import StepOne from '../Steps/StepOne'
import StepTwo from '../Steps/StepTwo'
import StepThree from '../Steps/StepThree'
import StepFour from '../Steps/StepFour'
import StepFive from '../Steps/StepFive'
import StepSix from '../Steps/StepSix'
import BriefForm from '@src/components/AdvertisingCampaign/Form/BriefForm'
import { Formik } from '@src/types/BriefNetwork/formikProps'
import { UserData } from '@src/types'

interface Props {
  userData: UserData | null
  sendStartFillingBriefAnalytics: () => void
}

const Brief: React.FC<Props & Formik> = props => {
  return (
    <BriefForm {...props}>
      <StepOne />
      <StepTwo />
      <StepThree />
      <StepFour />
      <StepFive />
      <StepSix />
    </BriefForm>
  )
}

export default Brief
